// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner_banner__uGgxt","title-wrapper":"Banner_title-wrapper__2WQ8K","title":"Banner_title__2c9IB","options":"Banner_options__ul6Bx"};